import { onMounted, onUnmounted } from "vue";
import type { Emitter, EventType, Handler } from "mitt";

/** Composable for handling mitt events without needing to manage the handler's lifecycle. Handler will automatically be unregistered on component unmounted. Use in vue components only. */
export function useMittEvent<Events extends Record<EventType, unknown>, Key extends keyof Events>(mitt: Emitter<Events>, event: Key, handler: Handler<Events[Key]>) {
    onMounted(() => {
        mitt.on(event, handler);
    });
    onUnmounted(() => {
        mitt.off(event);
    });
}